import {Injectable} from "@angular/core";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {DeviceAssociation} from "src/app/infrastructure/moovement-api/models/asset";
import AssetSample = Samples.AssetSample;

@Injectable({
  providedIn: 'root'
})
export class WaterLevelService {
  
  constructor() {}
  
  getLevelAsPercentageFor(assetSample: AssetSample<number>, association?: DeviceAssociation): number {
    if (!association) return 0;

    const nominalValue = association.sampleThresholds?.WaterLevel?.nominalValue;
    const measuredValue = assetSample.sample.value

    if (nominalValue === undefined || measuredValue === undefined) return 0;

    let percentage = this.calculatePercentage(measuredValue, nominalValue)
    if (percentage < 0) percentage = Math.abs(percentage);
    
    return Number.parseInt(percentage.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 0,
      useGrouping: false
    }));
  }
  
  private calculatePercentage(level: number, nominalValue: number) {
    return (level / nominalValue!) * 100
  }
}
